export enum PaymentErrorCodes {
  NONE,
  PAYMENT_EXPIRED,
  TOKEN_NOT_SUPPORTED,
  INSUFFICIENT_FUNDS,
  SIGNATURE_INVALID,
  PAYMENT_FAILURE,
  AMOUNT_ZERO,
  MARKET_NOT_SUPPORTED,
}
